// === Productpagina's: Multi column bullets (mobile only) ===
document.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth >= 750) return; // alleen mobiel

  // Vind alle Multi column secties (Broadcast)
  document.querySelectorAll('section[id^="SectionColumns--"], .shopify-section:has(.grid.multicolumn)').forEach(section => {
    const scroller = section.querySelector('.grid.multicolumn');
    if (!scroller) return;

    // Directe kinderen als "slides" (dek meerdere varianten af)
    const slides = Array.from(
      scroller.querySelectorAll(':scope > .grid-item, :scope > .column, :scope > .multicolumn-list__item, :scope > li')
    );
    if (slides.length === 0) return;

    // Bullets 1x aanmaken (als ze niet bestaan of aantal niet klopt)
    let bullets = section.querySelector('.mc-bullets');
    if (!bullets) {
      bullets = document.createElement('div');
      bullets.className = 'mc-bullets';
      scroller.insertAdjacentElement('afterend', bullets);
    }
    if (bullets.querySelectorAll('.dot').length !== slides.length) {
      bullets.innerHTML = '';
      slides.forEach((_, idx) => {
        const b = document.createElement('button');
        b.className = 'dot';
        b.setAttribute('aria-label', `Ga naar item ${idx + 1}`);
        b.dataset.i = String(idx + 1);
        bullets.appendChild(b);
      });
    }

    const dots = Array.from(bullets.querySelectorAll('.dot'));
    if (dots.length === 0) return;

    // Helpers
    function setActive(i) {
      dots.forEach((d, k) => {
        const active = k === i;
        d.classList.toggle('active', active);
        // visuele fallback ongeacht CSS-scoping
        d.style.background = active ? '#001871' : 'rgba(0,0,0,.25)';
      });
    }

    // Actieve index = slide waarvan het midden het dichtst bij het scroller-midden ligt
    function activeIndex() {
      const center = scroller.scrollLeft + scroller.clientWidth / 2;
      let best = 0, bestDist = Infinity;
      for (let i = 0; i < slides.length; i++) {
        const s = slides[i];
        const sCenter = s.offsetLeft + s.offsetWidth / 2;
        const dist = Math.abs(sCenter - center);
        if (dist < bestDist) { bestDist = dist; best = i; }
      }
      return best;
    }
    function syncActive() { setActive(activeIndex()); }

    // Klik op dot => naar betreffende slide scrollen
    dots.forEach((dot, idx) => {
      dot.addEventListener('click', (e) => {
        e.preventDefault();
        const target = slides[idx];
        if (!target) return;
        scroller.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
        setActive(idx);
      });
    });

    // Sync bij scroll / einde gesture / resize / load
    let ticking = false;
    scroller.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => { syncActive(); ticking = false; });
    }, { passive: true });

    ['touchend', 'pointerup', 'mouseup'].forEach(evt => {
      scroller.addEventListener(evt, () => { setTimeout(syncActive, 0); }, { passive: true });
    });

    window.addEventListener('resize', syncActive);
    window.addEventListener('load', syncActive);

    // Init
    syncActive();
  });
});
